import {create} from 'zustand';
import type {UseVoiceTranscriptionDrawerStoreProps} from './types';

export const useVoiceTranscriptionDrawerStore = create<UseVoiceTranscriptionDrawerStoreProps>(
	set => ({
		isOpen: false,
		telehealthUrl: null,
		origin: '',
		onError: null,
		onSuccess: null,
		onOpen: (url, origin, onError, onSuccess) =>
			set({
				isOpen: true,
				telehealthUrl: url,
				origin,
				onError: onError ?? null,
				onSuccess: onSuccess ?? null,
			}),
		onClose: () =>
			set({isOpen: false, telehealthUrl: null, origin: '', onError: null, onSuccess: null}),
	}),
);
